module.exports = __webpack_public_path__ + "img/content-bg.17d65806.png";